
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import BookListModal, { type ModalOption } from './BookListModal/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg,
    BookListModal
  }
})
export default class extends Vue {
  @Ref()
  bookListModal: {
    show: (data: ModalOption) => void
    hide: () => void
  }

  get Global() {
    return this.$store.$global
  }

  handleOpenBook() {
    this.bookListModal.show({
      imgList: [
        `${this.Global.static}/images/about-xuantong/pc/about-book-list-item0-v2.png`,
        `${this.Global.static}/images/about-xuantong/pc/about-book-list-item1-v2.png`,
        `${this.Global.static}/images/about-xuantong/pc/about-book-list-item2-v2.png`,
        `${this.Global.static}/images/about-xuantong/pc/about-book-list-item3-v2.png`,
        `${this.Global.static}/images/about-xuantong/pc/about-book-list-item4-v2.png`
      ],
      text: '暄桐书单'
    })
  }

  handleToBook(book: number) {
    window.open(`/books?id=${book}`)
  }

  handleOpenIns() {
    window.open('https://mp.weixin.qq.com/s/-sySInlQ6DmXqjZh2nh2cA')
  }

  handleOpenVideo() {
    window.open('/video')
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
